export default __webpack_public_path__ + "static/media/woman-new-mobile.9e2f37f7.png";